import type { ResumeDto } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { RESUMES_KEY } from "@/client/constants/query-keys";
import { axios } from "@/client/libs/axios";
import { useAuthStore } from "@/client/stores/auth";

export const fetchResumes = async () => {
  const response = await axios.get<ResumeDto[], AxiosResponse<ResumeDto[]>>("/resume");

  return response.data;
};

export const useResumes = (enabled = true) => {
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    data: resumes,
  } = useQuery({
    queryKey: RESUMES_KEY,
    queryFn: fetchResumes,
    enabled,
    retry: (failureCount, error: any) => {
      // Don't retry on auth errors - clear user state instead
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        console.log("Auth error in resumes fetch, clearing user state");
        setUser(null);
        return false;
      }
      // Retry other errors up to 3 times
      return failureCount < 3;
    },
  });

  return { resumes, loading, error };
};
